import React, { useState } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { InstagramWall } from './components/InstagramWall';
import { EventsPage } from './pages/EventsPage';
import { GalleryPage } from './pages/GalleryPage';
import { BottleServicePage } from './pages/BottleServicePage';
import { ReservationPage } from './pages/ReservationPage';
import { ContactPage } from './pages/ContactPage';
import { SeatingOptions } from './components/SeatingOptions';
import { FloorMap } from './components/FloorMap';
import { Footer } from './components/Footer';
import { FAQPage } from './pages/FAQPage';
import { FacilityBookingExcerpt } from './components/FacilityBookingExcerpt';
import { FacilityBookingPage } from './pages/FacilityBookingPage';
export type Page = 'home' | 'events' | 'gallery' | 'package-service' | 'reservation' | 'contact' | 'faq' | 'facility-booking';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const goHome = () => {
    setCurrentPage('home');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const goPage = (page: Page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full bg-[#050505] overflow-x-hidden" data-id="element-0">
      <Navigation currentPage={currentPage} setCurrentPage={goPage} data-id="element-1" />
      <main data-id="element-2">
        {currentPage === 'home' && <>
            <Hero onViewEvents={() => goPage('events')} onReserve={() => goPage('reservation')} data-id="element-3" />
            <InstagramWall data-id="element-4" />
            <SeatingOptions onViewPackages={() => goPage('package-service')} data-id="element-5" />
            <FloorMap data-id="element-6" />
            <FacilityBookingExcerpt onViewMore={() => goPage('facility-booking')} data-id="element-7" />
          </>}
        {currentPage === 'events' && <EventsPage onBack={goHome} data-id="element-8" />}
        {currentPage === 'gallery' && <GalleryPage onBack={goHome} data-id="element-9" />}
        {currentPage === 'package-service' && <BottleServicePage onBack={goHome} onReserve={() => goPage('reservation')} data-id="element-10" />}
        {currentPage === 'reservation' && <ReservationPage onBack={goHome} data-id="element-11" />}
        {currentPage === 'contact' && <ContactPage onBack={goHome} data-id="element-12" />}
        {currentPage === 'faq' && <FAQPage onBack={goHome} data-id="element-13" />}
        {currentPage === 'facility-booking' && <FacilityBookingPage onBack={goHome} data-id="element-14" />}
      </main>
      <Footer data-id="element-15" />
    </div>;
}